/* ============================================================
   Kabla · ABC de Drogas — datos de las 27 sustancias
   Archivo de datos (sin lógica). Para editar una ficha, cambia
   el objeto correspondiente. Los enlaces de producto apuntan a
   kabla.mx; ⚠️ REEMPLAZAR por URLs de producto de Shopify
   (/products/handle) cuando migren los productos.
   ============================================================ */
window.KABLA_ABC_DRUGS = [
 {
  "id": "anfetamina",
  "categoryKey": "est",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cup",
   "cas",
   "tira",
   "sal"
  ],
  "maxDays": 2,
  "sig": "AMP",
  "search": "anfetamina amp adderall® (anfetamina, dextroanfetamina) speed, anfetas, corazones, bombita, rosa, copilotos, bennies, dexies estimulante medicamentos y agentes terapéuticos (p. ej. selegilina, bupropión, pseudoefedrina).",
  "name": "Anfetamina",
  "category": "Estimulante",
  "window": "1–2 días",
  "windowRef": false,
  "cut": "1,000 ng/mL (también 300 ng/mL fuera de EE. UU.)",
  "samhsaRef": "500 ng/mL (grupo anfetamina/metanfetamina)",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Cassette individual",
   "Tira individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/anfetaminas/"
   },
   {
    "label": "Tira individual",
    "href": "https://producto.kabla.mx/producto/Toxicologia/DAM-101/prueba-para-deteccin-de-anfetamina-~amp~-en-tira---caja-con-50-pruebas---certum"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Anfetamina (AMP).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Adderall® (anfetamina, dextroanfetamina)"
     },
     {
      "label": "Nombres populares",
      "value": "Speed, anfetas, corazones, bombita, rosa, copilotos, bennies, dexies"
     },
     {
      "label": "Indicaciones",
      "value": "Trastorno por déficit de atención con hiperactividad (TDAH), narcolepsia. Usos históricos o restringidos: obesidad, depresión, broncodilatador."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista indirecto de receptores presinápticos de noradrenalina (NA) y dopamina (DA) en el SNC, con acción serotoninérgica. Impide que los transportadores de monoaminas recapturen DA y NA del espacio sináptico."
     },
     {
      "label": "Metabolitos",
      "value": "AMP"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Medicamentos y agentes terapéuticos (p. ej. selegilina, bupropión, pseudoefedrina)."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "50 ng/mL"
     },
     {
      "label": "Notas",
      "value": "Inhalador Vicks y selegilina: solo se detecta el isómero L (el isómero D es el presente en drogas ilícitas). La mayoría de los positivos se observaron con el doble de la dosis recomendada."
     }
    ]
   }
  ]
 },
 {
  "id": "metanfetamina",
  "categoryKey": "est",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cup",
   "sal"
  ],
  "maxDays": 4,
  "sig": "MET",
  "search": "metanfetamina met desoxyn® cristal, ice, hielo, fuego, cruz blanca, cristina, speed estimulante medicamentos y agentes terapéuticos.",
  "name": "Metanfetamina",
  "category": "Estimulante",
  "window": "2–4 días",
  "windowRef": true,
  "cut": "1,000 ng/mL; 500 y 300 ng/mL (fuera de EE. UU.)",
  "samhsaRef": "500 ng/mL (grupo anfetamina/metanfetamina)",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Metanfetamina (MET).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Desoxyn®"
     },
     {
      "label": "Nombres populares",
      "value": "Cristal, ice, hielo, fuego, cruz blanca, cristina, speed"
     },
     {
      "label": "Indicaciones",
      "value": "TDAH (uso muy restringido)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista en los transportadores de noradrenalina, dopamina y serotonina; inhibe su recaptura y produce estimulación del SNC."
     },
     {
      "label": "Metabolitos",
      "value": "Anfetamina (4–7 %)"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Medicamentos y agentes terapéuticos."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "50 ng/mL"
     }
    ]
   }
  ]
 },
 {
  "id": "cocaina",
  "categoryKey": "est",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cup",
   "cas",
   "sal"
  ],
  "maxDays": 2,
  "sig": "COC",
  "search": "cocaína coc en desuso como medicamento coca, nieve, polvo, blanca, perico, copos de nieve estimulante no se conocen interferentes comunes.",
  "name": "Cocaína",
  "category": "Estimulante",
  "window": "1–2 días",
  "windowRef": false,
  "cut": "300 ng/mL y 150 ng/mL",
  "samhsaRef": "150 ng/mL (benzoilecgonina); confirmación 100 ng/mL",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/cassette-certum/cocaina/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Cocaína (COC).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "En desuso como medicamento"
     },
     {
      "label": "Nombres populares",
      "value": "Coca, nieve, polvo, blanca, perico, copos de nieve"
     },
     {
      "label": "Indicaciones",
      "value": "Anestésico tópico (uso histórico y muy limitado)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Bloquea la recaptura de serotonina, dopamina y noradrenalina, principalmente en el sistema mesocorticolímbico, con acumulación rápida de estas monoaminas."
     },
     {
      "label": "Metabolitos",
      "value": "Benzoilecgonina, ecgonina y metil-éster de ecgonina"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "No se conocen interferentes comunes."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "15 ng/mL (cocaína/benzoilecgonina)"
     }
    ]
   }
  ]
 },
 {
  "id": "opiaceos",
  "categoryKey": "opi",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cup",
   "cas",
   "sal"
  ],
  "maxDays": 3,
  "sig": "OPI · MOP",
  "search": "opiáceos / opioides opi · mop naturales: codeína, morfina, tebaína, papaverina, noscapina. semisintéticos y sintéticos: hidrocodona, oxicodona, hidromorfona, metadona. — opioide medicamentos y agentes terapéuticos (p. ej. quinolonas, rifampicina).",
  "name": "Opiáceos / opioides",
  "category": "Opioide",
  "window": "1–3 días",
  "windowRef": false,
  "cut": "OPI 2,000 ng/mL; MOP 300 ng/mL",
  "samhsaRef": "2,000 ng/mL (codeína/morfina); 300 ng/mL (hidrocodona/hidromorfona)",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/opiaceos-morfina/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Opiáceos / opioides (OPI · MOP).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Naturales: codeína, morfina, tebaína, papaverina, noscapina. Semisintéticos y sintéticos: hidrocodona, oxicodona, hidromorfona, metadona."
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Analgesia, supresión de la tos, espasmolítico."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Activan receptores opioides acoplados a proteína G: inhiben la adenilciclasa (menos AMPc), abren canales de K⁺ y cierran canales de Ca²⁺, lo que hiperpolariza la célula."
     },
     {
      "label": "Metabolitos",
      "value": "Morfina"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Medicamentos y agentes terapéuticos (p. ej. quinolonas, rifampicina)."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "30 ng/mL (codeína/morfina)"
     },
     {
      "label": "Notas",
      "value": "La prueba de opiáceos detecta morfina y codeína; no detecta de forma confiable fentanilo, metadona, oxicodona ni buprenorfina. Para esas sustancias se requiere su prueba específica."
     }
    ]
   }
  ]
 },
 {
  "id": "fenciclidina",
  "categoryKey": "alu",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cas",
   "sal"
  ],
  "maxDays": 30,
  "sig": "PCP",
  "search": "fenciclidina pcp sernyl® (descontinuado; sernylan® de uso veterinario) polvo de ángel, ozono, píldora de la paz, polvo de estrellas alucinógeno / disociativo venlafaxina, lamotrigina, dextrometorfano, imipramina, ketamina, meperidina, mesoridazina, quinolonas, tioridazina, tramadol.",
  "name": "Fenciclidina",
  "category": "Alucinógeno / disociativo",
  "window": "2–7 días; hasta 30 días en uso crónico",
  "windowRef": true,
  "cut": "25 ng/mL",
  "samhsaRef": "25 ng/mL",
  "formats": [
   "Panel (dip card)",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/fenciclidina/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Fenciclidina (PCP).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Sernyl® (descontinuado; Sernylan® de uso veterinario)"
     },
     {
      "label": "Nombres populares",
      "value": "Polvo de ángel, ozono, píldora de la paz, polvo de estrellas"
     },
     {
      "label": "Indicaciones",
      "value": "Anestésico quirúrgico (en desuso)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Antagonista del receptor NMDA. Causa una despolarización prolongada de la neurona; su efecto sobre los receptores de glutamato es potente y duradero."
     },
     {
      "label": "Metabolitos",
      "value": "PCP hidroxilada"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Venlafaxina, lamotrigina, dextrometorfano, imipramina, ketamina, meperidina, mesoridazina, quinolonas, tioridazina, tramadol."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "10 ng/mL"
     },
     {
      "label": "Notas",
      "value": "Falso positivo confirmado por GC-MS tras ingesta intencional masiva de venlafaxina."
     }
    ]
   }
  ]
 },
 {
  "id": "marihuana",
  "categoryKey": "can",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cup",
   "cas",
   "sal"
  ],
  "maxDays": 28,
  "sig": "THC",
  "search": "marihuana thc dronabinol (análogo sintético) mota, hierba, porro, churro, monte, ganja cannabinoide efavirenz, aine (ibuprofeno, naproxeno), dronabinol.",
  "name": "Marihuana",
  "category": "Cannabinoide",
  "window": "Uso ocasional 1–7 días; crónico 1–4 semanas",
  "windowRef": false,
  "cut": "50 ng/mL (THC-COOH)",
  "samhsaRef": "50 ng/mL; confirmación 15 ng/mL",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/cassette-certum/marihuana/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Marihuana (THC).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Dronabinol (análogo sintético)"
     },
     {
      "label": "Nombres populares",
      "value": "Mota, hierba, porro, churro, monte, ganja"
     },
     {
      "label": "Indicaciones",
      "value": "En estudio o aprobado en algunos países: dolor neuropático, espasticidad en esclerosis múltiple, náusea por quimioterapia."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista de receptores CB1, que inhiben la adenilato ciclasa. Induce una mezcla de efectos excitatorios e inhibitorios y suprime la liberación de neurotransmisores."
     },
     {
      "label": "Metabolitos",
      "value": "Carboxi-THC (THC-COOH)"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Efavirenz, AINE (ibuprofeno, naproxeno), dronabinol."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "4 ng/mL (THC)"
     },
     {
      "label": "Notas",
      "value": "Tasa reportada de falsos positivos: 0.4 %."
     }
    ]
   }
  ]
 },
 {
  "id": "benzodiazepinas",
  "categoryKey": "sed",
  "samhsa": false,
  "formatKeys": [
   "panel",
   "cup",
   "cas",
   "sal"
  ],
  "maxDays": 7,
  "sig": "BZO",
  "search": "benzodiazepinas bzo diazepam (valium®), clordiazepóxido (librium®), alprazolam (xanax®), clonazepam (klonopin®) — sedante / hipnótico interferentes reportados: sertralina, oxaprozina, efavirenz. la prueba también reconoce otras bzd como bromazepam, flunitrazepam o clorazepato.",
  "name": "Benzodiazepinas",
  "category": "Sedante / hipnótico",
  "window": "3–7 días",
  "windowRef": false,
  "cut": "300 ng/mL y 200 ng/mL (oxazepam)",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/benzodiacepinas/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Benzodiazepinas (BZO).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Diazepam (Valium®), clordiazepóxido (Librium®), alprazolam (Xanax®), clonazepam (Klonopin®)"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Ansiedad, insomnio, agitación, convulsiones, espasmo muscular."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Potencian el efecto inhibitorio del GABA al unirse a su sitio en el receptor GABA-A. El canal de cloro permanece abierto, la membrana se hiperpolariza y la neurona resiste la excitación."
     },
     {
      "label": "Metabolitos",
      "value": "Oxazepam (calibrador habitual)"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Interferentes reportados: sertralina, oxaprozina, efavirenz. La prueba también reconoce otras BZD como bromazepam, flunitrazepam o clorazepato."
     },
     {
      "label": "Notas",
      "value": "Las BZD que no se metabolizan a oxazepam (clonazepam, lorazepam, alprazolam) pueden dar falsos negativos en pruebas calibradas con oxazepam."
     }
    ]
   }
  ]
 },
 {
  "id": "barbituricos",
  "categoryKey": "sed",
  "samhsa": false,
  "formatKeys": [
   "panel",
   "cup",
   "cas",
   "sal"
  ],
  "maxDays": 21,
  "sig": "BAR",
  "search": "barbitúricos bar fenobarbital, pentobarbital, butalbital (fiorinal®) — sedante / hipnótico fenitoína, aine (ibuprofeno, naproxeno). la prueba también reconoce alobarbital, amobarbital, aprobarbital y butabarbital.",
  "name": "Barbitúricos",
  "category": "Sedante / hipnótico",
  "window": "Acción corta 1–3 días; fenobarbital 1–3 semanas",
  "windowRef": false,
  "cut": "300 ng/mL (secobarbital)",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Panel (dip card)",
   "Simple Cup",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Simple Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/simple-cup-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/cassette-certum/barbituricos/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Barbitúricos (BAR).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Fenobarbital, pentobarbital, butalbital (Fiorinal®)"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Anticonvulsivo. Ansiolítico e hipnótico (sustituidos por las benzodiazepinas)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Estimulan el sistema inhibitorio GABA y mantienen abiertos los canales de cloro; la membrana se hiperpolariza y la neurona resiste la excitación."
     },
     {
      "label": "Metabolitos",
      "value": "Variable según el fármaco. El ensayo se calibra con secobarbital."
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Fenitoína, AINE (ibuprofeno, naproxeno). La prueba también reconoce alobarbital, amobarbital, aprobarbital y butabarbital."
     },
     {
      "label": "Notas",
      "value": "Tasa reportada de falsos positivos: 0.4 %."
     }
    ]
   }
  ]
 },
 {
  "id": "metadona",
  "categoryKey": "opi",
  "samhsa": false,
  "formatKeys": [
   "panel",
   "sal"
  ],
  "maxDays": 5,
  "sig": "MTD",
  "search": "metadona mtd eptadone® — opioide α-metadol, difenhidramina, doxilamina, tioridazina, verapamilo.",
  "name": "Metadona",
  "category": "Opioide",
  "window": "3–5 días",
  "windowRef": false,
  "cut": "300 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Panel (dip card)",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Metadona (MTD).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Eptadone®"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Dolor intenso; programas de desintoxicación y mantenimiento en dependencia a opioides."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista completo del receptor μ-opioide. La dextrometadona no actúa sobre receptores opioides; se une al receptor NMDA como antagonista del glutamato."
     },
     {
      "label": "Metabolitos",
      "value": "EDDP (primario), EMDP (secundario)"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "α-metadol, difenhidramina, doxilamina, tioridazina, verapamilo."
     },
     {
      "label": "Notas",
      "value": "Puede no detectarse en pacientes metabolizadores muy rápidos; en ese caso conviene medir EDDP."
     }
    ]
   }
  ]
 },
 {
  "id": "antidepresivos-triciclicos",
  "categoryKey": "otr",
  "samhsa": false,
  "formatKeys": [
   "panel",
   "cas"
  ],
  "maxDays": 10,
  "sig": "TCA",
  "search": "antidepresivos tricíclicos tca amitriptilina, nortriptilina, desipramina, clomipramina — otros carbamazepina (dosis altas), ciproheptadina, hidroxizina, quetiapina.",
  "name": "Antidepresivos tricíclicos",
  "category": "Otros",
  "window": "7–10 días",
  "windowRef": false,
  "cut": "1,000 ng/mL (también 300 ng/mL)",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Panel (dip card)",
   "Cassette individual"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/tca/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Antidepresivos tricíclicos (TCA).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Amitriptilina, nortriptilina, desipramina, clomipramina"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Depresión mayor moderada o grave."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Bloquean la recaptura de serotonina y noradrenalina, lo que eleva sus niveles en el encéfalo."
     },
     {
      "label": "Metabolitos",
      "value": "—"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Carbamazepina (dosis altas), ciproheptadina, hidroxizina, quetiapina."
     }
    ]
   }
  ]
 },
 {
  "id": "oxicodona",
  "categoryKey": "opi",
  "samhsa": true,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 3,
  "sig": "OXY",
  "search": "oxicodona oxy percodan®, percocet®, oxycontin®, roxicodone®, oxecta®, oxyir®, endone®, oxynorm® — opioide su estructura no es lo bastante parecida a la codeína o la morfina: la prueba de opiáceos regular no la detecta de forma confiable.",
  "name": "Oxicodona",
  "category": "Opioide",
  "window": "1–3 días",
  "windowRef": false,
  "cut": "100 ng/mL",
  "samhsaRef": "100 ng/mL (grupo oxicodona/oximorfona)",
  "formats": [
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Oxicodona (OXY).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Percodan®, Percocet®, OxyContin®, Roxicodone®, Oxecta®, OxyIR®, Endone®, OxyNorm®"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Dolor moderado a intenso cuando la morfina falló o no se toleró."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista puro de receptores μ y κ, sin techo terapéutico. Algunos autores describen también acción sobre receptores δ."
     },
     {
      "label": "Metabolitos",
      "value": "Oximorfona, noroxicodona"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Su estructura no es lo bastante parecida a la codeína o la morfina: la prueba de opiáceos regular no la detecta de forma confiable."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "30 ng/mL"
     }
    ]
   }
  ]
 },
 {
  "id": "propoxifeno",
  "categoryKey": "opi",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 2,
  "sig": "PPX",
  "search": "propoxifeno ppx darvon® y darvocet® (retirados del mercado por la fda en 2010) — opioide aunque se parece estructuralmente a la metadona, no reacciona de forma cruzada en pruebas de opiáceos ni de metadona.",
  "name": "Propoxifeno",
  "category": "Opioide",
  "window": "6–48 horas",
  "windowRef": true,
  "cut": "300 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Propoxifeno (PPX).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Darvon® y Darvocet® (retirados del mercado por la FDA en 2010)"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Dolor leve a moderado (retirado)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Se une principalmente a receptores μ-opioides; produce analgesia y efectos similares a los de la morfina."
     },
     {
      "label": "Metabolitos",
      "value": "Norpropoxifeno"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Aunque se parece estructuralmente a la metadona, no reacciona de forma cruzada en pruebas de opiáceos ni de metadona."
     },
     {
      "label": "Notas",
      "value": "La mayoría de los laboratorios no lo confirman de forma automática; hay que solicitarlo."
     }
    ]
   }
  ]
 },
 {
  "id": "mdma",
  "categoryKey": "est",
  "samhsa": true,
  "formatKeys": [
   "panel",
   "cas",
   "sal"
  ],
  "maxDays": 5,
  "sig": "MDMA",
  "search": "mdma (éxtasis) mdma — éxtasis, adán, xtc, tachas, droga del amor estimulante reacciona parcialmente en pruebas de metanfetamina, pero con sensibilidad insuficiente; por eso existe una prueba específica de mdma, sensible también a mda y mdea.",
  "name": "MDMA (éxtasis)",
  "category": "Estimulante",
  "window": "1–5 días",
  "windowRef": true,
  "cut": "500 ng/mL",
  "samhsaRef": "500 ng/mL (grupo MDMA/MDA)",
  "formats": [
   "Panel (dip card)",
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Panel (dip card)",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/panel-certum/"
   },
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/extasis/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para MDMA (éxtasis) (MDMA).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "—"
     },
     {
      "label": "Nombres populares",
      "value": "Éxtasis, Adán, XTC, tachas, droga del amor"
     },
     {
      "label": "Indicaciones",
      "value": "Sin indicación aprobada. En investigación para estrés postraumático resistente a tratamiento."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista directo de receptores presinápticos de serotonina. Aumenta la liberación de serotonina, dopamina y noradrenalina, inhibe su recaptura e interfiere con la monoaminooxidasa."
     },
     {
      "label": "Metabolitos",
      "value": "MDA (principal), HMMA"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Reacciona parcialmente en pruebas de metanfetamina, pero con sensibilidad insuficiente; por eso existe una prueba específica de MDMA, sensible también a MDA y MDEA."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "50 ng/mL"
     }
    ]
   }
  ]
 },
 {
  "id": "lsd",
  "categoryKey": "alu",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 3,
  "sig": "LSD",
  "search": "lsd (dietilamida de ácido lisérgico) lsd — ácido, tripi, sellos, ajos, secantes, soles alucinógeno / disociativo amitriptilina.",
  "name": "LSD (dietilamida de ácido lisérgico)",
  "category": "Alucinógeno / disociativo",
  "window": "Aprox. 1–3 días (datos limitados)",
  "windowRef": true,
  "cut": "20 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para LSD (dietilamida de ácido lisérgico) (LSD).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "—"
     },
     {
      "label": "Nombres populares",
      "value": "Ácido, tripi, sellos, ajos, secantes, soles"
     },
     {
      "label": "Indicaciones",
      "value": "Sin indicación terapéutica aprobada."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Imita a la serotonina en receptores 5-HT (incluidos 5-HT1A y 5-HT2A); reduce marcadamente la tasa de disparo de las neuronas serotoninérgicas."
     },
     {
      "label": "Metabolitos",
      "value": "N-desmetil-LSD, hidroxi-LSD, 2-oxo-LSD, 2-oxo-3-hidroxi-LSD"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Amitriptilina."
     },
     {
      "label": "Notas",
      "value": "Se usa en dosis de microgramos, por lo que su ventana de detección es corta y muy variable."
     }
    ]
   }
  ]
 },
 {
  "id": "metilfenidato",
  "categoryKey": "est",
  "samhsa": false,
  "formatKeys": [
   "cas"
  ],
  "maxDays": 2,
  "sig": "MPD",
  "search": "metilfenidato mpd ritalin®, concerta®, daytrana® — estimulante no se conocen. puede producir falsos positivos en la prueba de anfetaminas.",
  "name": "Metilfenidato",
  "category": "Estimulante",
  "window": "Aprox. 2 días",
  "windowRef": false,
  "cut": "100, 150 o 300 ng/mL según fabricante",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Cassette individual"
  ],
  "productLinks": [
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/cassette-certum/metilfenidato/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Metilfenidato (MPD).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Ritalin®, Concerta®, Daytrana®"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "TDAH; segunda línea en narcolepsia. Fuera de indicación: fatiga por cáncer, depresión refractaria en adultos mayores, apatía en Alzheimer."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Bloquea la recaptura de noradrenalina y dopamina en neuronas presinápticas, lo que aumenta su concentración en la hendidura sináptica."
     },
     {
      "label": "Metabolitos",
      "value": "Ácido ritalínico"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "No se conocen. Puede producir falsos positivos en la prueba de anfetaminas."
     }
    ]
   }
  ]
 },
 {
  "id": "fentanilo",
  "categoryKey": "opi",
  "samhsa": true,
  "formatKeys": [
   "cas",
   "sal"
  ],
  "maxDays": 2,
  "sig": "FYL",
  "search": "fentanilo fyl sublimaze®, actiq®, fentora®, abstral®, subsys®, lazanda®, duragesic® apache, china girl, china town, dance fever, goodfellas, jackpot, murder 8, tango & cash opioide no se conocen interferentes comunes.",
  "name": "Fentanilo",
  "category": "Opioide",
  "window": "1–2 días",
  "windowRef": false,
  "cut": "1, 2 o 20 ng/mL según fabricante",
  "samhsaRef": "1 ng/mL (fentanilo/norfentanilo)",
  "formats": [
   "Cassette individual",
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/fentanilo/"
   },
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Fentanilo (FYL).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Sublimaze®, Actiq®, Fentora®, Abstral®, Subsys®, Lazanda®, Duragesic®"
     },
     {
      "label": "Nombres populares",
      "value": "Apache, China girl, China town, dance fever, goodfellas, jackpot, murder 8, tango & cash"
     },
     {
      "label": "Indicaciones",
      "value": "Anestesia y analgesia en dolor intenso; dolor crónico en pacientes con tolerancia a opioides; sedación en pacientes intubados."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista potente del receptor μ-opioide (depresor del SNC); unas 50 veces más potente que la heroína y 100 veces más que la morfina."
     },
     {
      "label": "Metabolitos",
      "value": "Norfentanilo"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "No se conocen interferentes comunes."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "4 ng/mL"
     },
     {
      "label": "Notas",
      "value": "No se detecta con la prueba de opiáceos convencional; requiere su prueba específica."
     }
    ]
   }
  ]
 },
 {
  "id": "heroina",
  "categoryKey": "opi",
  "samhsa": true,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 2,
  "sig": "6-MAM",
  "search": "heroína (6-mam) 6-mam diacetilmorfina (sin uso médico en méxico) chiva, caballo, h, negra, brea opioide la 6-mam no se forma a partir de codeína, morfina ni semillas de amapola: un positivo a 6-mam distingue la heroína de esas fuentes.",
  "name": "Heroína (6-MAM)",
  "category": "Opioide",
  "window": "Menos de 1 día; 1–2 días en uso frecuente",
  "windowRef": true,
  "cut": "10 ng/mL",
  "samhsaRef": "10 ng/mL",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Heroína (6-MAM) (6-MAM).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Diacetilmorfina (sin uso médico en México)"
     },
     {
      "label": "Nombres populares",
      "value": "Chiva, caballo, H, negra, brea"
     },
     {
      "label": "Indicaciones",
      "value": "Sin indicación terapéutica en México."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Profármaco de la morfina: se desacetila a 6-monoacetilmorfina (6-MAM) y luego a morfina, que activa los receptores μ-opioides."
     },
     {
      "label": "Metabolitos",
      "value": "6-monoacetilmorfina (marcador exclusivo de heroína), morfina"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "La 6-MAM no se forma a partir de codeína, morfina ni semillas de amapola: un positivo a 6-MAM distingue la heroína de esas fuentes."
     },
     {
      "label": "Referencia SAMHSA en saliva",
      "value": "4 ng/mL"
     },
     {
      "label": "Notas",
      "value": "La prueba de opiáceos (morfina) también sale positiva, pero no permite diferenciar heroína de morfina, codeína o amapola."
     }
    ]
   }
  ]
 },
 {
  "id": "tramadol",
  "categoryKey": "opi",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 4,
  "sig": "TRA",
  "search": "tramadol tra tradol®, ultram®, tramacet® (con paracetamol) — opioide no se detecta con la prueba de opiáceos convencional; requiere su prueba específica. puede dar falso positivo en la prueba de pcp.",
  "name": "Tramadol",
  "category": "Opioide",
  "window": "Aprox. 1–4 días",
  "windowRef": true,
  "cut": "100 ng/mL",
  "samhsaRef": "No incluido en el panel federal",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Tramadol (TRA).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Tradol®, Ultram®, Tramacet® (con paracetamol)"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Dolor moderado a intenso."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista débil del receptor μ-opioide (sobre todo por su metabolito O-desmetiltramadol) e inhibidor de la recaptura de serotonina y noradrenalina."
     },
     {
      "label": "Metabolitos",
      "value": "O-desmetiltramadol (M1), N-desmetiltramadol"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "No se detecta con la prueba de opiáceos convencional; requiere su prueba específica. Puede dar falso positivo en la prueba de PCP."
     },
     {
      "label": "Notas",
      "value": "De uso frecuente en México y con venta controlada; conviene incluirlo en programas laborales de transporte y manufactura."
     }
    ]
   }
  ]
 },
 {
  "id": "buprenorfina",
  "categoryKey": "opi",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 4,
  "sig": "BUP",
  "search": "buprenorfina bup temgesic®, transtec®, suboxone® (con naloxona) — opioide no se detecta con la prueba de opiáceos convencional; requiere su prueba específica.",
  "name": "Buprenorfina",
  "category": "Opioide",
  "window": "3–4 días",
  "windowRef": true,
  "cut": "10 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Buprenorfina (BUP).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Temgesic®, Transtec®, Suboxone® (con naloxona)"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Dolor moderado a intenso; tratamiento de mantenimiento en dependencia a opioides."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista parcial del receptor μ-opioide con alta afinidad y antagonista κ; tiene efecto techo en la depresión respiratoria."
     },
     {
      "label": "Metabolitos",
      "value": "Norbuprenorfina"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "No se detecta con la prueba de opiáceos convencional; requiere su prueba específica."
     },
     {
      "label": "Notas",
      "value": "Útil para verificar adherencia en programas de tratamiento."
     }
    ]
   }
  ]
 },
 {
  "id": "ketamina",
  "categoryKey": "alu",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 14,
  "sig": "KET",
  "search": "ketamina ket ketalar®, ketanest® (uso humano y veterinario); esketamina (spravato®) keta, k, special k, vitamina k alucinógeno / disociativo puede dar positivo en la prueba de pcp por similitud estructural.",
  "name": "Ketamina",
  "category": "Alucinógeno / disociativo",
  "window": "Aprox. 2–4 días; más en uso crónico",
  "windowRef": true,
  "cut": "1,000 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Ketamina (KET).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Ketalar®, Ketanest® (uso humano y veterinario); esketamina (Spravato®)"
     },
     {
      "label": "Nombres populares",
      "value": "Keta, K, special K, vitamina K"
     },
     {
      "label": "Indicaciones",
      "value": "Inducción anestésica, sedación, analgesia; esketamina en depresión resistente."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Antagonista no competitivo del receptor NMDA; produce anestesia disociativa, analgesia y, a dosis bajas, efecto antidepresivo rápido."
     },
     {
      "label": "Metabolitos",
      "value": "Norketamina, deshidronorketamina"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Puede dar positivo en la prueba de PCP por similitud estructural."
     },
     {
      "label": "Notas",
      "value": "Su metabolito norketamina se detecta más tiempo que la ketamina."
     }
    ]
   }
  ]
 },
 {
  "id": "cannabinoides-sinteticos",
  "categoryKey": "can",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 7,
  "sig": "K2",
  "search": "cannabinoides sintéticos (k2) k2 — k2, spice, mamba negra cannabinoide no se detectan con la prueba de marihuana (thc). cada ensayo cubre solo ciertas familias; las moléculas nuevas pueden escapar.",
  "name": "Cannabinoides sintéticos (K2)",
  "category": "Cannabinoide",
  "window": "Hasta 72 horas (uso único); más en uso crónico",
  "windowRef": true,
  "cut": "50 ng/mL (también 25 y 10 ng/mL)",
  "samhsaRef": "No incluidos en el panel federal",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Cannabinoides sintéticos (K2) (K2).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "—"
     },
     {
      "label": "Nombres populares",
      "value": "K2, spice, mamba negra"
     },
     {
      "label": "Indicaciones",
      "value": "Sin indicación terapéutica."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonistas completos y muy potentes de los receptores CB1 y CB2, a diferencia del THC, que es agonista parcial. Por eso su toxicidad es mayor."
     },
     {
      "label": "Metabolitos",
      "value": "Metabolitos de JWH-018, JWH-073, AB-PINACA, UR-144 y otros"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "No se detectan con la prueba de marihuana (THC). Cada ensayo cubre solo ciertas familias; las moléculas nuevas pueden escapar."
     },
     {
      "label": "Notas",
      "value": "El mercado cambia rápido de molécula: un negativo no descarta consumo de un cannabinoide sintético nuevo."
     }
    ]
   }
  ]
 },
 {
  "id": "catinonas-sinteticas",
  "categoryKey": "est",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 3,
  "sig": "MDPV · α-PVP",
  "search": "catinonas sintéticas mdpv · α-pvp — sales de baño, flakka estimulante generalmente no se detectan con las pruebas de anfetaminas ni de metanfetamina; requieren ensayos específicos.",
  "name": "Catinonas sintéticas",
  "category": "Estimulante",
  "window": "Variable, generalmente pocos días",
  "windowRef": true,
  "cut": "Según inserto del fabricante",
  "samhsaRef": "No incluidas en el panel federal",
  "formats": [
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Catinonas sintéticas (MDPV · α-PVP).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "—"
     },
     {
      "label": "Nombres populares",
      "value": "Sales de baño, flakka"
     },
     {
      "label": "Indicaciones",
      "value": "Sin indicación terapéutica."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Inhiben la recaptura de dopamina y noradrenalina (MDPV y α-PVP con gran potencia); efecto estimulante similar a la cocaína y la metanfetamina."
     },
     {
      "label": "Metabolitos",
      "value": "Variables según la molécula"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Generalmente no se detectan con las pruebas de anfetaminas ni de metanfetamina; requieren ensayos específicos."
     },
     {
      "label": "Notas",
      "value": "Familia de sustancias en constante cambio; la confirmación por espectrometría de masas es clave."
     }
    ]
   }
  ]
 },
 {
  "id": "etilglucuronido",
  "categoryKey": "otr",
  "samhsa": false,
  "formatKeys": [
   "cas"
  ],
  "maxDays": 5,
  "sig": "ETG",
  "search": "alcohol (etilglucurónido) etg — — otros exposición incidental a productos con alcohol (enjuague bucal, gel antibacterial, medicamentos en jarabe) puede dar valores bajos positivos.",
  "name": "Alcohol (etilglucurónido)",
  "category": "Otros",
  "window": "Hasta 5 días (corte 500 ng/mL)",
  "windowRef": true,
  "cut": "500 ng/mL",
  "samhsaRef": "No incluido en el panel federal",
  "formats": [
   "Cassette individual",
   "Alcoholimetría Kabla"
  ],
  "productLinks": [
   {
    "label": "Cassette individual",
    "href": "https://kabla.mx/pruebasrapidas/pruebas-de-drogas/cassette-certum/etil-glucuronido/"
   },
   {
    "label": "Alcoholimetría Kabla",
    "href": "https://alcoholimetria.kabla.mx/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Alcohol (etilglucurónido) (ETG).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "—"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Monitoreo de abstinencia en programas laborales, clínicos y de rehabilitación."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "El etilglucurónido es un metabolito directo del etanol. Su presencia indica consumo reciente de alcohol aunque el alcohol ya no esté en sangre ni aliento."
     },
     {
      "label": "Metabolitos",
      "value": "Etilglucurónido (EtG), etilsulfato (EtS)"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "Exposición incidental a productos con alcohol (enjuague bucal, gel antibacterial, medicamentos en jarabe) puede dar valores bajos positivos."
     },
     {
      "label": "Notas",
      "value": "Detecta consumo de días previos, a diferencia del alcoholímetro, que mide intoxicación actual."
     }
    ]
   }
  ]
 },
 {
  "id": "cotinina",
  "categoryKey": "otr",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 10,
  "sig": "COT",
  "search": "nicotina (cotinina) cot parches, chicles y pastillas de reemplazo de nicotina — otros la terapia de reemplazo de nicotina y el vapeo también dan positivo. la exposición pasiva intensa puede dar valores bajos.",
  "name": "Nicotina (cotinina)",
  "category": "Otros",
  "window": "Aprox. 2–4 días; más en fumadores intensos",
  "windowRef": true,
  "cut": "200 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Nicotina (cotinina) (COT).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Parches, chicles y pastillas de reemplazo de nicotina"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Verificar estatus de fumador (seguros, programas de bienestar, cesación tabáquica)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "La cotinina es el principal metabolito de la nicotina; tiene una vida media mucho más larga, por lo que es el marcador preferido de exposición al tabaco."
     },
     {
      "label": "Metabolitos",
      "value": "Cotinina, 3-hidroxicotinina"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "La terapia de reemplazo de nicotina y el vapeo también dan positivo. La exposición pasiva intensa puede dar valores bajos."
     }
    ]
   }
  ]
 },
 {
  "id": "ghb",
  "categoryKey": "sed",
  "samhsa": false,
  "formatKeys": [],
  "maxDays": 1,
  "sig": "GHB",
  "search": "ghb ghb oxibato de sodio (xyrem®) éxtasis líquido, g sedante / hipnótico el cuerpo produce ghb endógeno en pequeñas cantidades; la interpretación requiere niveles de corte adecuados.",
  "name": "GHB",
  "category": "Sedante / hipnótico",
  "window": "Generalmente menos de 12–24 horas",
  "windowRef": true,
  "cut": "Según inserto del fabricante",
  "samhsaRef": "No incluido en el panel federal",
  "formats": [
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para GHB (GHB).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Oxibato de sodio (Xyrem®)"
     },
     {
      "label": "Nombres populares",
      "value": "Éxtasis líquido, G"
     },
     {
      "label": "Indicaciones",
      "value": "Narcolepsia con cataplejía (oxibato de sodio)."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Agonista del receptor GABA-B y de su propio receptor GHB; depresor del SNC con margen de seguridad estrecho."
     },
     {
      "label": "Metabolitos",
      "value": "Se metaboliza casi por completo a CO₂ y agua"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "El cuerpo produce GHB endógeno en pequeñas cantidades; la interpretación requiere niveles de corte adecuados."
     },
     {
      "label": "Notas",
      "value": "Ventana muy corta: en casos de sospecha de sumisión química, la muestra debe tomarse cuanto antes."
     }
    ]
   }
  ]
 },
 {
  "id": "metacualona",
  "categoryKey": "sed",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 4,
  "sig": "MQL",
  "search": "metacualona mql quaalude®, mandrax® (retirados del mercado) ludes, mandrax sedante / hipnótico —",
  "name": "Metacualona",
  "category": "Sedante / hipnótico",
  "window": "Aprox. 2–4 días",
  "windowRef": true,
  "cut": "300 ng/mL",
  "samhsaRef": "No incluida en el panel federal",
  "formats": [
   "Saliva Cup",
   "Más opciones Kabla"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   },
   {
    "label": "Más opciones Kabla",
    "href": "https://kabla.mx/toxicologia/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Metacualona (MQL).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Quaalude®, Mandrax® (retirados del mercado)"
     },
     {
      "label": "Nombres populares",
      "value": "Ludes, mandrax"
     },
     {
      "label": "Indicaciones",
      "value": "Sin uso médico actual."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Sedante-hipnótico que potencia la acción del GABA en el receptor GABA-A, en un sitio distinto al de benzodiazepinas y barbitúricos."
     },
     {
      "label": "Metabolitos",
      "value": "Metabolitos hidroxilados"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "—"
     },
     {
      "label": "Notas",
      "value": "Su consumo es poco frecuente hoy; se incluye en algunos paneles ampliados de tradición estadounidense."
     }
    ]
   }
  ]
 },
 {
  "id": "carisoprodol",
  "categoryKey": "sed",
  "samhsa": false,
  "formatKeys": [
   "sal"
  ],
  "maxDays": 4,
  "sig": "CAR",
  "search": "carisoprodol car soma®; en méxico en combinaciones con analgésicos — sedante / hipnótico —",
  "name": "Carisoprodol",
  "category": "Sedante / hipnótico",
  "window": "Aprox. 1–2 días; meprobamato algo más",
  "windowRef": true,
  "cut": "Según inserto del fabricante",
  "samhsaRef": "No incluido en el panel federal",
  "formats": [
   "Saliva Cup"
  ],
  "productLinks": [
   {
    "label": "Saliva Cup",
    "href": "https://kabla.mx/toxicologia/pruebas-rapidas-de-drogas/saliva-certum/"
   }
  ],
  "quoteLink": "https://api.whatsapp.com/send?phone=5218144441001&text=Hola, quiero cotizar una prueba Certum para Carisoprodol (CAR).",
  "sections": [
   {
    "title": "Identificación",
    "items": [
     {
      "label": "Medicamentos",
      "value": "Soma®; en México en combinaciones con analgésicos"
     },
     {
      "label": "Nombres populares",
      "value": "—"
     },
     {
      "label": "Indicaciones",
      "value": "Espasmo muscular agudo y doloroso."
     }
    ]
   },
   {
    "title": "Farmacología",
    "items": [
     {
      "label": "Mecanismo",
      "value": "Relajante muscular de acción central; su metabolito meprobamato actúa sobre el receptor GABA-A con efecto sedante y ansiolítico."
     },
     {
      "label": "Metabolitos",
      "value": "Meprobamato"
     }
    ]
   },
   {
    "title": "Detección",
    "items": [
     {
      "label": "Reactividad cruzada",
      "value": "—"
     },
     {
      "label": "Notas",
      "value": "Riesgo de abuso al combinarse con opioides y benzodiazepinas."
     }
    ]
   }
  ]
 }
];